// extracted by mini-css-extract-plugin
export default {"root":"NXr0W","section":"_2Cel4","progress":"_1JDts","success":"gFM7Y","note":"UqB5j","brand":"ETVl0"};